import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _ from 'lodash';
import _fetch from 'isomorphic-fetch';
import path from 'path';
import queryString from 'query-string';
var TTL = 5;
var DATAPATH = 'data';
/**
 * Fetch implementation used by this module.
 *
 * It can be useful in tests to override this using `setFetch` fn.
 */

var fetch = _fetch;
/**
 * Set different fetch implementation. Useful in tests.
 */

export function setFetch(_fetch) {
  fetch = _fetch;
}
/**
 * Reset fetch implementation to default one.
 */

export function resetFetch() {
  fetch = _fetch;
}
/**
 * Request helper. Creates an request to backend.
 * @param localConfig
 * @param apiPath - path to backend endpoint (hostname taken from config)
 * @param method - HTTP method
 * @param query - url query as object
 * @param payload - payload as object
 * @param ttl - (optional) number of tries
 * @param dataPath - (optional) [default: "data"] Path where should data be. If response object does not have data on "dataPath", then return Error.
 * @returns response or error
 */

export default function request(localConfig, apiPath, method, query, payload) {
  var ttl = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : TTL;
  var dataPath = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : DATAPATH;
  var url = localConfig.apiBackendProtocol + '://' + path.join(localConfig.apiBackendHost, localConfig.apiBackendPath, apiPath);

  if (query) {
    url += '?' + queryString.stringify(query);
  }

  return fetch(url, {
    method: method,
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    },
    body: payload ? JSON.stringify(payload) : null
  }).then(function (response) {
    var contentType = response.headers.get('Content-type');

    if (response.ok && contentType && contentType.indexOf('application/json') !== -1) {
      return response.json().then(function (body) {
        if (dataPath === null || dataPath && _.get(body, dataPath)) {
          return _objectSpread(_objectSpread({}, body), {}, {
            status: response.status
          });
        } else {
          throw new Error('no data returned');
        }
      });
    } else {
      throw new Error('response error');
    }
  }, function (error) {
    if (ttl - 1) {
      request(localConfig, apiPath, method, query, payload, ttl - 1);
    } else {
      throw error;
    }
  });
}